// Vendor-agnostic email subscription wrapper.
//
// Feature code calls `email.subscribe(...)` and never touches a vendor SDK.
// Today the adapter is Brevo (POSTs to our own Lambda which talks to Brevo).
// To swap to Mailchimp/Klaviyo/etc., add a new adapter and re-export it here.

import { brevoProvider } from './brevo'

export type EmailLocale = 'da' | 'en'
export type NewsletterSource = 'footer' | 'modal' | 'page'

/**
 * Maps a site locale (any of the 11 supported) down to the two locales the
 * email provider supports. Non-English locales collapse to Danish (the brand's
 * primary language) until the provider gains those templates. Lives here, inside
 * the vendor-agnostic email boundary, so callers never compare locale literals
 * themselves (which the locale-registry eslint rule forbids outside this lib).
 */
export function toEmailLocale(lang: string): EmailLocale {
  return lang === 'en' ? 'en' : 'da'
}

export interface SubscribeInput {
  email: string
  locale: EmailLocale
  source: NewsletterSource
  /** Honeypot value - backend silently drops the request when non-empty. */
  honeypot?: string
  /** Privacy-policy version the user consented to. */
  consentVersion?: string
}

export interface EmailProvider {
  subscribe(input: SubscribeInput): Promise<SubscribeResult>
}

export type SubscribeResult =
  | { ok: true }
  | { ok: false; reason: 'invalid_email' | 'rate_limited' | 'network' | 'server' }

export const email: EmailProvider = brevoProvider
